const shortDateString2Date = (dateString) => {
  if (!dateString) return null;
  if (typeof dateString == "string") {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6)
    const day = dateString.substring(6, 8);
    var a = new Date(`${year}-${month}-${day}T00:00:00`);
    return a;
  }
  return dateString;
};
export default shortDateString2Date;